var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFire2 = function SvgFire2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9442623,11.9525 C19.9442623,10.85 19.6229508,9.275 19.4622951,8.96 C20.9081967,9.7475 23.8,11.6375 23.8,17.3075 C23.8,22.3475 19.4622951,26.6 14,26.6 C8.53770492,26.6 4.2,22.3475 4.2,17.3075 C4.2,14.315 5.4852459,11.795 7.25245902,10.22 C13.1967213,4.55 13.0360656,1.5575 13.1967213,1.4 C15.2852459,2.975 16.7311475,5.0225 16.5704918,7.7 C16.5704918,9.905 14.8032787,14 17.8557377,14.4725 C19.3016393,14.63 19.9442623,12.8975 19.9442623,11.9525 Z",
    fillRule: "evenodd"
  })));
};
export default SvgFire2;